
var $accountAdminSearchForm = $('.page-accountAdmin form#belimoAccountAdministratorForm');
if($accountAdminSearchForm.length > 0) {
  var $searchButton = $('.page-accountAdmin .account-admin-form-ctrls .form-search-ctrls button');
  $searchButton.on('click', function(){
    $accountAdminSearchForm.submit();
  });
}
